import { UserLayout } from '@/layout';
import { ajax } from '@/store/midPromise';
import { public_info } from '@/store/model/reducers/golbal';
import { api_index } from '@/store/model/reducers/index';
import { LockOutlined, MessageOutlined, UserOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Input, Tabs, message } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import './index.less';
const { TabPane } = Tabs;

const windowObj = global.windows || window;

// 密码校验：长度 8–20，4 类字符至少满足 3类
const passwordRules = [
    { required: true, message: '请输入新密码!' },
    {
        validator: (_: any, value: string) => {
            if (!value) return Promise.resolve();
            if (value.length < 8 || value.length > 20) {
                return Promise.reject('您设置的密码不符合要求');
            }
            let count = 0;
            if (/[A-Z]/.test(value)) count += 1; // 大写
            if (/[a-z]/.test(value)) count += 1; // 小写
            if (/[0-9]/.test(value)) count += 1; // 数字
            if (/[\~\!\@\#\$\%\^\*\(\)\-\+\_\=\.\,]/.test(value)) count += 1; // 特殊
            if (count < 3) {
                return Promise.reject('您设置的密码不符合要求');
            }
            return Promise.resolve();
        },
    },
];

const tailLayout = {
    wrapperCol: { offset: 0, span: 24 },
};

interface Interfaceprops extends RouteComponentProps {
    userLogin: (data: any) => void;
    get_public: () => void;
}

let phone = '';
const Index: React.FC<Interfaceprops> = props => {
    // console.log(props)
    const [formLogin] = Form.useForm();
    const [formPassword] = Form.useForm();
    const [activeKey, setactiveKey] = useState('1');
    const [msgText, setmsgText] = useState('获取验证码');
    const [msgdisabled, setmsgdisabled] = useState(false);

    const callback = (key: string) => {
        // console.log(key);
        setactiveKey(key);
    };
    const getCode = (t: number) => {
        if (t <= 0) {
            setmsgdisabled(false);
            setmsgText(`重新获取`);
            return;
        }
        setmsgdisabled(true);
        setmsgText(`${t}s后重新获取`);
        setTimeout(() => getCode(t - 1), 1000);
    };
    const getMsg = () => {
        phone = formLogin.getFieldValue('phone');
        phone = phone && phone.replace(/\s+/g, '');
        if (phone.length !== 11) return;
        getCode(60);
        ajax.post('/api/auth/getCode', { phone: phone }).then((res: any) => {
            if (!(res && res.code === 200)) getCode(0);
        });
    };

    const onFinish = (values: any) => {
        phone = formLogin.getFieldValue('phone');
        phone = phone && phone.replace(/\s+/g, '');
        if (values.testCode) {
            values.smsCode = values.testCode; // 将验证码转存为 smsCode
            delete values.testCode; // 移除多余字段
        }
        ajax.post('/api/auth/reset', { ...values, ...{ phone: phone } }).then((res: any) => {
            if (res && res.code === 200) {
                setactiveKey('2');
            }
        });
    };
    const onSetPassword = (data: any) => {
        if (data.confirmPassword !== data.password) {
            formPassword.resetFields();
            message.error('两次密码不一致');
            return;
        }
        ajax.put('/api/auth/resetPassword', { ...data, ...{ phone: phone } }).then((res: any) => {
            if (res && res.code === 200) {
                message.success('密码重置成功');
                props.history.push('/user/login');
            }
        });
    };

    return (
        <UserLayout>
            {/*<Row>*/}
            {/*<Col span={8} offset={8}>*/}
            <div className={'layoutLogin'}>
                <Tabs
                    activeKey={activeKey}
                    className={'userTabs'}
                    // renderTabBar={tabBar}
                >
                    <TabPane tab="验证手机号" key="1">
                        <Form name="basic" form={formLogin} onFinish={onFinish}>
                            <Form.Item
                                wrapperCol={{ span: 24 }}
                                name="phone"
                                rules={[
                                    { required: true, message: '请输入账户（手机号码）!' },
                                    { len: 11, message: '手机号格式有误' },
                                ]}
                            >
                                <Input
                                    prefix={<UserOutlined className="site-form-item-icon" />}
                                    placeholder="账户（手机号码）"
                                />
                            </Form.Item>
                            <Form.Item
                                wrapperCol={{ span: 24 }}
                                name="testCode"
                                rules={[{ required: true, message: '请输入验证码!' }]}
                            >
                                <p>
                                    <Input
                                        type="text"
                                        prefix={<MessageOutlined className="site-form-item-icon" />}
                                        style={{ width: '65%' }}
                                        className="code"
                                        placeholder="请输入验证码"
                                    />
                                    <Button
                                        type="primary"
                                        style={{ width: '35%' }}
                                        disabled={msgdisabled}
                                        onClick={getMsg}
                                    >
                                        {msgText}
                                    </Button>
                                </p>
                            </Form.Item>

                            <Form.Item {...tailLayout} className="btnForm">
                                <Button type="primary" htmlType="submit" className="loginBtn">
                                    确定
                                </Button>
                            </Form.Item>
                        </Form>
                    </TabPane>
                    <TabPane tab="重置密码" key="2" disabled={true}>
                        <Alert
                            type="warning"
                            showIcon
                            style={{ marginBottom: 16, borderRadius: 6 }}
                            message={
                                <div style={{ lineHeight: '19px' }}>
                                    <strong style={{ display: 'block', marginBottom: 8 }}>
                                        密码要求
                                    </strong>
                                    <ol style={{ paddingLeft: 24, margin: '0 0 0 -30px' }}>
                                        <li style={{ marginBottom: 4 }}>
                                            大写字母（A‑Z）、小写字母（a‑z）、数字（0‑9）、特殊字符（~!@#$%^*()‑+_=,.），
                                            4 个类别至少选择 3 个类别
                                        </li>
                                        <li style={{ marginBottom: 4 }}>
                                            最小长度 8 位，最大长度 20 位
                                        </li>
                                        <li>新密码不能与上次旧密码一致</li>
                                    </ol>
                                </div>
                            }
                        />
                        <Form name="basic" form={formPassword} onFinish={onSetPassword}>
                            <Form.Item
                                wrapperCol={{ span: 24 }}
                                name="password"
                                rules={passwordRules}
                            >
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    placeholder="请输入新密码"
                                />
                            </Form.Item>
                            <Form.Item
                                wrapperCol={{ span: 24 }}
                                name="confirmPassword"
                                rules={[
                                    { required: true, message: '请确认新密码!' },
                                    {
                                        validator: (_, value) => {
                                            if (
                                                !value ||
                                                formPassword.getFieldValue('password') === value
                                            ) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('两次密码不一致');
                                        },
                                    },
                                ]}
                            >
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    placeholder="请确认新密码"
                                />
                            </Form.Item>

                            <Form.Item {...tailLayout} className="btnForm">
                                <Button type="primary" htmlType="submit" className="loginBtn">
                                    确定
                                </Button>
                            </Form.Item>
                        </Form>
                    </TabPane>
                </Tabs>
            </div>
            {/*</Col>*/}
            {/*</Row>*/}
        </UserLayout>
    );
};

const mapStateProps = (state: any) => {
    return {
        // loginInfo: state.user.login,
        // registerInfo: state.user.register,
        // username:state.index.username,
        // password:state.index.password
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        userLogin: (data: any) => {
            // console.log(data)
            console.log('userLogin __002');
            dispatch(api_index(data)('login'));
        },
        get_public: () => {
            console.log('get_public __002');
            dispatch(public_info());
        },
    };
};

export default connect(mapStateProps, mapDispatchToProps)(Index);
